import _implicitStylesheets from "./header.css";
import _implicitScopedStylesheets from "./header.scoped.css?scoped=true";
import _aceTbid from "ace/tbid";
import _aceNotifications from "ace/notifications";
import _searchTypeAhead from "search/typeAhead";
import _aceHelpCenter from "ace/helpCenter";
import _aceAppLauncher from "ace/appLauncher";
import _aceOrgContextMenu from "ace/orgContextMenu";
import _aceFavorites from "ace/favorites";
import _aceUserMenu from "ace/userMenu";
import _wdsButton from "wds/button";
import _axIcon from "ax/icon";
import _axBadge from "ax/badge";
import _wdsAvatar from "wds/avatar";
import _axMarketplaceHeaderMobileMenuItem from "ax/marketplaceHeaderMobileMenuItem";
import _aceHelpCenterMobile from "ace/helpCenterMobile";
import _aceUserMenuMobile from "ace/userMenuMobile";
import _axMarketplaceHeader from "ax/marketplaceHeader";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="org-card-name${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<span class="org-card-email${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span class="org-card-domain${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<button class="org-card__switch-link${0}" data-testid="switch-org"${2}>${"t1"}</button>`;
const stc0 = {
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  slotAssignment: "search",
  key: 3
};
const stc3 = {
  slotAssignment: "utility",
  classMap: {
    "header-utility": true
  },
  key: 4
};
const stc4 = {
  "utility-item": true
};
const stc5 = {
  classMap: {
    "utility-item": true,
    "app-launcher": true
  },
  key: 6
};
const stc6 = {
  classMap: {
    "utility-item": true
  },
  key: 7
};
const stc7 = {
  classMap: {
    "utility-item": true
  },
  key: 8
};
const stc8 = {
  classMap: {
    "utility-item": true
  },
  key: 9
};
const stc9 = {
  "utility-item": true,
  "header-button": true
};
const stc10 = {
  "data-testid": "signup"
};
const stc11 = {
  "data-testid": "login"
};
const stc12 = {
  slotAssignment: "utilityMobile",
  classMap: {
    "header-utility-mobile": true
  },
  key: 12
};
const stc13 = {
  classMap: {
    "org-card": true
  },
  key: 13
};
const stc14 = {
  classMap: {
    "org-card-header": true
  },
  key: 14
};
const stc15 = {
  "org-card-cloud": true
};
const stc16 = {
  classMap: {
    "org-card-meta": true
  },
  key: 22
};
const stc17 = {
  "org-card__edition": true
};
const stc18 = {
  "data-testid": "mobile-user-menu-button"
};
const stc19 = {
  slotAssignment: "customMobileMenuPane",
  key: 32
};
const stc20 = {
  key: 33
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, b: api_bind, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11} = $ctx;
  return [api_custom_element("ace-tbid", _aceTbid, stc0), api_custom_element("ace-notifications", _aceNotifications, stc1), api_custom_element("ax-marketplace-header", _axMarketplaceHeader, {
    props: {
      "marketplaceOptions": $cmp.marketplaceOptions,
      "selectedMarketplace": $cmp.selectedMarketplace,
      "navOptions": $cmp.navOptions,
      "logoHref": $cmp.links.home,
      "iconSpriteUrl": "/images/icons.svg",
      "brandText": $cmp.brandText,
      "marketplaceSwitcherAriaLabel": $cmp.labels.marketplaceSwitcherAriaLabel,
      "mainNavigationAriaLabel": $cmp.labels.mainNavigationAriaLabel,
      "menuAriaLabel": $cmp.labels.menuAriaLabel,
      "mobileSubNavigationAriaLabel": $cmp.labels.mobileSubNavigationAriaLabel,
      "mobileBackLabel": $cmp.labels.mobileBackLabel
    },
    key: 2,
    on: {
      "navclick": _m0 || ($ctx._m0 = api_bind($cmp.handleNavClick)),
      "headerheightchange": _m1 || ($ctx._m1 = api_bind($cmp.handleHeaderHeightChange))
    }
  }, [api_custom_element("search-type-ahead", _searchTypeAhead, stc2), api_element("div", stc3, [api_custom_element("ace-help-center", _aceHelpCenter, {
    classMap: stc4,
    props: {
      "isLoggedIn": $cmp.isLoggedIn
    },
    key: 5
  }), $cmp.isLoggedIn ? api_custom_element("ace-app-launcher", _aceAppLauncher, stc5) : null, $cmp.isLoggedIn ? $cmp.showOrgContextMenu ? api_custom_element("ace-org-context-menu", _aceOrgContextMenu, stc6) : null : null, $cmp.isLoggedIn ? !$cmp.showOrgContextMenu ? api_custom_element("ace-favorites", _aceFavorites, stc7) : null : null, $cmp.isLoggedIn ? !$cmp.showOrgContextMenu ? api_custom_element("ace-user-menu", _aceUserMenu, stc8) : null : null, !$cmp.isLoggedIn ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc9,
    attrs: stc10,
    props: {
      "size": "small",
      "name": "headerSignup",
      "label": $cmp.labels.signup
    },
    key: 10,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.signup))
    }
  }) : null, !$cmp.isLoggedIn ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc9,
    attrs: stc11,
    props: {
      "variant": "secondary",
      "size": "small",
      "name": "headerLogin",
      "label": $cmp.labels.login
    },
    key: 11,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.login))
    }
  }) : null]), api_element("div", stc12, [$cmp.isLoggedIn ? $cmp.showOrgCard ? api_element("div", stc13, [api_element("span", stc14, [api_custom_element("ax-icon", _axIcon, {
    classMap: stc15,
    props: {
      "icon": "salesforce",
      "spriteUrl": "/images/icons.svg",
      "size": "small",
      "iconDescription": $cmp.orgIconDescription
    },
    key: 15
  }), api_static_fragment($fragment1, 17, [api_static_part(0, {
    attrs: {
      "title": $cmp.orgName
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.orgName))])]), api_static_fragment($fragment2, 19, [api_static_part(0, {
    attrs: {
      "title": $cmp.selectedOrg.username
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.username))]), $cmp.hasDomain ? api_static_fragment($fragment3, 21, [api_static_part(0, {
    attrs: {
      "title": $cmp.selectedOrg.domain
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.selectedOrg.domain))]) : null, api_element("span", stc16, [$cmp.hasEdition ? api_custom_element("ax-badge", _axBadge, {
    classMap: stc17,
    props: {
      "text": $cmp.selectedOrg.edition,
      "theme": $cmp.editionBadgeTheme
    },
    key: 23
  }) : null, api_static_fragment($fragment4, 25, [api_static_part(0, {
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleSwitchOrg))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.switchOrgLabel))])])]) : null : null, $cmp.isLoggedIn ? api_custom_element("ax-marketplace-header-mobile-menu-item", _axMarketplaceHeaderMobileMenuItem, {
    attrs: stc18,
    props: {
      "itemType": "sub-nav-item",
      "text": $cmp.mobileUserMenuLabel,
      "rightIcon": "chevronright",
      "iconSpriteUrl": "/images/icons.svg"
    },
    key: 26,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleMobileUserMenuClick))
    }
  }, [$cmp.userProfileImage ? api_custom_element("wds-avatar", _wdsAvatar, {
    slotAssignment: "leftContent",
    props: {
      "src": $cmp.userProfileImage,
      "alt": "",
      "size": "small"
    },
    key: 27
  }) : null]) : null, $cmp.isLoggedIn ? api_custom_element("ax-marketplace-header-mobile-menu-item", _axMarketplaceHeaderMobileMenuItem, {
    props: {
      "itemType": "sub-nav-item",
      "text": $cmp.favoritesLabel,
      "leftIcon": "favorite-heart",
      "iconSpriteUrl": "/images/icons.svg",
      "href": $cmp.favoritesHref,
      "target": "_self"
    },
    key: 28,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handleMobileFavoritesClick))
    }
  }) : null, !$cmp.isLoggedIn ? api_custom_element("ax-marketplace-header-mobile-menu-item", _axMarketplaceHeaderMobileMenuItem, {
    props: {
      "itemType": "sub-nav-item",
      "text": $cmp.labels.login,
      "leftIcon": "user-full",
      "iconSpriteUrl": "/images/icons.svg"
    },
    key: 29,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.login))
    }
  }) : null, !$cmp.isLoggedIn ? api_custom_element("ax-marketplace-header-mobile-menu-item", _axMarketplaceHeaderMobileMenuItem, {
    props: {
      "itemType": "sub-nav-item",
      "text": $cmp.labels.signup,
      "leftIcon": "edit",
      "iconSpriteUrl": "/images/icons.svg"
    },
    key: 30,
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.signup))
    }
  }) : null, api_custom_element("ax-marketplace-header-mobile-menu-item", _axMarketplaceHeaderMobileMenuItem, {
    props: {
      "itemType": "sub-nav-item",
      "text": $cmp.helpCenterTitle,
      "leftIcon": "help-filled",
      "rightIcon": "chevronright",
      "iconSpriteUrl": "/images/icons.svg"
    },
    key: 31,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleMobileHelpCenterClick))
    }
  })]), api_element("div", stc19, [$cmp.showMobileHelpCenterMenu ? api_custom_element("ace-help-center-mobile", _aceHelpCenterMobile, stc20) : null, $cmp.showMobileUserMenu ? api_custom_element("ace-user-menu-mobile", _aceUserMenuMobile, {
    key: 34,
    on: {
      "requestclose": _m11 || ($ctx._m11 = api_bind($cmp.handleUserMenuClose))
    }
  }) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-380pk3clve5";
tmpl.legacyStylesheetToken = "undefined-_header";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
